import React from "react"
import EmailCampaignPresenterGeneral from './EmailCampaignPresenterGeneral'
import EmailCampaignPresenterCustomers from './EmailCampaignPresenterCustomers'
import EmailCampaignPresenterEmails from './EmailCampaignPresenterEmails'
import EmailCampaignBuilderCustomerPreview from '../EmailCampaignBuilder/EmailCampaignBuilderCustomerPreview'

export default class EmailCampaignPresenterWorkspace extends React.Component {
  constructor(props){
    super(props);
  };

  render(){
    return(
      <div className="panel panel-default">
        <div className="panel-body">
          {this.renderSteps()}
        </div>
      </div>
    );
  };

  renderSteps() {
    switch (true) {
      case this.props.step === 'general': return <EmailCampaignPresenterGeneral {...this.props} />
      case this.props.step === 'customer_details': return <EmailCampaignPresenterCustomers {...this.props} />
      case this.props.step === 'email_templates': return <EmailCampaignPresenterEmails {...this.props} />
      case this.props.step === 'customers_preview': return <EmailCampaignBuilderCustomerPreview {...this.props} />
    };
  };
};
